import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import '@styles/App.scss';
import '@styles/custom.scss';
import '@styles/global.scss';
import appRoutes from './routes/routes';
import AppLayout from './components/AppLayout';
import { App as AntApp } from 'antd'
import { Suspense, useEffect } from 'react';
import PageLoading from './components/PageLoading';
import { useAppDispatch } from './hooks';
import { loadUser } from './features/oidc/oidcSlice';

const AppRoutes = () => useRoutes(appRoutes);

function App() {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(loadUser())
    }, [dispatch])
    
    return (
        <AntApp>
            <Router>
                <AppLayout>
                    <Suspense
                        fallback={<PageLoading />}>
                        <AppRoutes />
                    </Suspense>
                </AppLayout>
            </Router>
        </AntApp>
    );
}

export default App;
